import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper'
import { createToast } from 'mosha-vue-toastify'
import { useAuthStore } from '@/stores/auth.store'

import i18n, { setI18nLanguage } from '../i18n'

const { t } = i18n().global

const handleResponse = (message, type) => {
  createToast(message, {
    hideProgressBar: true,
    type: type, // 'danger' or 'success'
    showIcon: true,
    position: 'bottom-right'
  })
}

export const useAnalystStore = defineStore({
  id: 'analyst',
  state: () => ({
    // initialize state properties
    analystId: null,
    name: null,
    lastname: null,
    email: null,
    language: null,
    companyName: null,
    error: null,
    loading: false
  }),
  actions: {
    // Get analyst's personal data.
    fetchPersonalInfo () {
      this.analystId = null
      this.name = null
      this.lastname = null
      this.email = null
      this.language = null
      this.companyName = null
      this.error = null
      this.loading = true
      fetchWrapper.get(`${process.env.VUE_APP_API_BASE}/analysts/analysts`)
        .then((response) => {
          this.analystId = response.id
          this.name = response.name
          this.lastname = response.lastname
          this.email = response.email
          this.language = response.language
          this.companyName = response.company_name
        }).catch((error) => {
          this.error = error
          const message = t('genericError')
          handleResponse(message, 'danger')
        }).finally(() => {
          this.loading = false
        })
    },
    // Update analyst personal data.
    updatePersonalInfo (analystId, params) {
      this.loading = true
      this.error = null
      fetchWrapper.put(`${process.env.VUE_APP_API_BASE}/analysts/analysts/${analystId}`, params)
        .then((response) => {
          const analyst = response.analyst
          this.name = analyst.name
          this.lastname = analyst.lastname
          this.email = analyst.email
          this.language = analyst.language
          setI18nLanguage(this.language)
          const message = t('dataUpdatedSuccessfully')
          handleResponse(message, 'success')
        }).catch((error) => {
          this.error = error
          const message = t('genericError')
          handleResponse(message, 'danger')
        }).finally(() => {
          this.loading = false
        })
    },
    // Update passsword
    updatePassword (params) {
      const { authorizeWithToken } = useAuthStore()
      this.loading = true
      fetchWrapper.put(`${process.env.VUE_APP_API_BASE}/analysts/sessions`, params)
        .then((response) => {
          // Update analyst credentials store
          const analyst = {
            type: 'analyst',
            credentials: { token: response.token }
          }
          authorizeWithToken(analyst, response.language)
          const message = t('passwordUpdatedSuccessfully')
          handleResponse(message, 'success')
        }).catch((error) => {
          this.error = error
          const message = t('genericError')
          handleResponse(message, 'danger')
        }).finally(() => {
          this.loading = false
        })
    }
  }
})
